module.exports = __webpack_public_path__ + "img/logo.04eee96d.png";